import {
  Component,
  EventEmitter,
  Input,
  OnInit,
  Output,
  ViewChild,
} from "@angular/core";
import { UsersList } from "../../../../core/models/users/users/usersList";
import { UntilDestroy, untilDestroyed } from "@ngneat/until-destroy";
import { UserSupportMapService } from "../../../../core/services/user-support-map.service";
import { SupportUserListComponent } from "../support-user-list/support-user-list.component";
import { UserRole } from "../../../../shared/enums/userRoles.enum";
import { Table, TableModule } from "primeng/table";
import { CommonModule } from "@angular/common";
import { FormsModule } from "@angular/forms";
import { Checkbox, CheckboxChangeEvent } from "primeng/checkbox";
import { ConfirmDialogComponent } from "../../../../shared/components/confirm-dialog/confirm-dialog.component";
import { DatePickerModule } from "primeng/datepicker";
import { InputNumberModule } from "primeng/inputnumber";
import { JniToastrService } from "../../../../core/services/jni-toastr.service";
import { UserSupportMap } from "../../../../core/models/profile/userSupport";
import { DeleteUserSupport } from "../../../../core/models/profile/deleteUserSupport";
import { SpinnerComponent } from "../../../../shared/components/spinner/spinner.component";
import { CalendarParserPipe } from "../../../../shared/pipes/calendarParser/calendar-parser.pipe";

@UntilDestroy()
@Component({
  selector: "jni-user-support-map",
  templateUrl: "./user-support-map.component.html",
  standalone: true,
  imports: [
    TableModule,
    SupportUserListComponent,
    CommonModule,
    FormsModule,
    Checkbox,
    ConfirmDialogComponent,
    DatePickerModule,
    InputNumberModule,
    SpinnerComponent,
  ],
  styleUrls: ["./user-support-map.component.scss"],
})
export class UserSupportMapComponent implements OnInit {
  @ViewChild("dt") table!: Table;

  @Input() userProfileTableData: UserSupportMap[] = [];
  @Input() userProfileAddTableData: UsersList[] = [];
  @Input() gridheading = "";
  deletebuttonEnable = false;
  currentdata!: Date;
  userDisplayModal = false;
  selectedUserId = 0;

  showSmallLoader = false;
  @Output() refreshDataEvent = new EventEmitter<string>();
  @Output() refreshDataIsPrimaryEvent = new EventEmitter<string>();
  @Output() redirectionEvent = new EventEmitter();
  @Input() userId = "";

  dateObj = new Date();
  public loading = false;
  public selectedUsers: UserSupportMap[] = [];
  userIds: number[] = [];
  UserSupportMapIds?: DeleteUserSupport;
  popupmessage = "";
  username = "";
  dialogStatus = false;
  supportGridRights = true;
  @ViewChild("usersupportmap", { static: false })
  usersupportmap!: SupportUserListComponent;
  @Output() emitSupportUserModalShow = new EventEmitter<number>();

  constructor(
    private _userSupportMapService: UserSupportMapService,
    private _toastr: JniToastrService
  ) {}

  ngOnInit(): void {
    setTimeout(() => {
      this.currentdata = new Date();
    }, 4000);
  }
  smallLoaderCall(status: boolean) {
    if (status) {
      this.showSmallLoader = true;
    } else {
      this.showSmallLoader = false;
    }
  }

  refreshTableData(gridheading: string) {
    this.refreshDataEvent.emit(gridheading);
  }

  onCheckboxStateChange(
    supportUserMapObj: UserSupportMap,
    event: CheckboxChangeEvent
  ) {
    this.showSmallLoader = true;
    const inVal =
      (event?.originalEvent?.target as HTMLInputElement | null)?.id ?? "";

    // Comment as per the ticket #13709
    // const expireDate = this.isExpiredDateValidation(
    //   supportUserMapObj.expiresOn ?? ""
    // );
    // const objVal: string = inVal.id;

    // if (expireDate) {
    //   this._toastr.error("Error", `Cannot modify expired record`);
    //   this.showSmallLoader = false;
    //   supportUserMapObj[objVal] = false;
    //   return;
    // }

    this.updateData(supportUserMapObj as UserSupportMap, inVal);
  }

  updateData(supportUserMapObj: UserSupportMap, emitIsPrimary = "") {
    this._userSupportMapService
      .updateWhoSupportMeAndI(supportUserMapObj)
      .pipe(untilDestroyed(this))
      .subscribe({
        next: () => {
          if (emitIsPrimary == "isPrimary") {
            this.refreshDataIsPrimaryEvent.emit();
          }
          this.showSmallLoader = false;
        },
        error: () => {
          this.showSmallLoader = false;
        },
      });
  }

  onSupportPercentageFocusOutEvent(supportUserMapObj: UserSupportMap) {
    this.showSmallLoader = true;

    if (supportUserMapObj.support > 100) {
      supportUserMapObj.support = 100;
    }
    if (supportUserMapObj.support < 0) {
      supportUserMapObj.support = 0;
    }

    // if (average > 100) {
    //   this._toastr.error(
    //     'Error',
    //     "Consolidated support % shouldn't be exceeding 100%"
    //   );
    //   this.showSmallLoader = false;
    //   supportUserMapObj.support = 0;
    //   return;
    // }

    this.updateData(supportUserMapObj as UserSupportMap);
  }

  closeUserModal() {
    this.userDisplayModal = false;
  }

  dateSelectionEvent(
    supportUserMapObj: UserSupportMap,
    dateSelected: Date | null
  ) {
    this.showSmallLoader = true;
    if (dateSelected === null) {
      // Date was cleared
      supportUserMapObj.expiresOn = null;
    } else {
      const calendarParserPipe = new CalendarParserPipe();
      supportUserMapObj.expiresOn = calendarParserPipe.transform(dateSelected);
    }

    this.updateData(supportUserMapObj as UserSupportMap);
  }

  onDeleteUsers() {
    if (this.selectedUsers.length > 0) {
      this.showSmallLoader = true;
      this.userIds = [];
      for (const user of this.selectedUsers) {
        this.userIds.push(user.id);
      }

      this.UserSupportMapIds = {
        UserSupportMapIds: this.userIds,
      };
      this._userSupportMapService
        .deleteUserSupportMap(this.UserSupportMapIds)
        .pipe(untilDestroyed(this))
        .subscribe({
          next: () => {
            this.selectedUsers.length = 0;
            this.refreshTableData(this.gridheading);
            this._toastr.success("Success", "User deleted Successfully");
            this.showSmallLoader = false;
          },
          error: () => {
            this._toastr.error("Error", "Error deleting user");
            this.showSmallLoader = false;
          },
        });
    }
  }

  deleteDialog(status: string) {
    if (this.selectedUsers.length == 1) {
      if (status == "Who I Support") {
        this.username = this.selectedUsers[0].user.name;
        this.deleteAlert(status);
      } else if (status == "Who Supports Me") {
        this.username = this.selectedUsers[0].supportUser.name;
        this.deleteAlert(status);
      }
    } else if (this.selectedUsers.length > 1) {
      this.username = this.selectedUsers.length.toLocaleString();
      this.deleteAlert(status);
    }
  }

  deleteAlert(status: string) {
    this.popupmessage = `Are you sure you want to delete ${this.username} user from (${status})`;
    this.dialogStatus = true;
  }

  confirmDialogStatusData(status: boolean) {
    this.dialogStatus = false;
    if (status) {
      this.onDeleteUsers();
    }
  }

  deleteButtonEnable(event: boolean) {
    this.deletebuttonEnable = event;
  }

  onUserClickRedirect(userId: number, expiredate: Date) {
    const date = new Date();
    if (date < new Date(expiredate)) {
      this.selectedUserId = userId;
      //this.userDisplayModal = true;
      this.emitSupportUserModalShow.emit(this.selectedUserId);
    } else {
      if (!expiredate) {
        // this._router.navigate(['/profile', userId]);
        this.selectedUserId = userId;
        //this.userDisplayModal = true;
        this.emitSupportUserModalShow.emit(this.selectedUserId);
      } else {
        this._toastr.error("Error", "This support relation is expired");
      }
    }
  }

  isExpiredDateValidation(expiredate: string | Date) {
    if (expiredate !== null) {
      const date = new Date();
      if (date < new Date(expiredate)) {
        return false;
      } else {
        return true;
      }
    } else {
      return false;
    }
  }

  isGoingToExpired(expiredate: Date) {
    const expireDate = new Date(expiredate);
    const diffDays = this.calculateDiff(expireDate);
    if (diffDays >= 1 && diffDays < 31) {
      return true;
    } else {
      return false;
    }
  }

  calculateDiff(dateSent: Date) {
    const currentDate = new Date(dateSent);
    dateSent = new Date();

    return Math.floor(
      (Date.UTC(
        currentDate.getFullYear(),
        currentDate.getMonth(),
        currentDate.getDate()
      ) -
        Date.UTC(
          dateSent.getFullYear(),
          dateSent.getMonth(),
          dateSent.getDate()
        )) /
        (1000 * 60 * 60 * 24)
    );
  }

  getUserRoleId(object: { userRoleId: number; currentId: number }) {
    if (
      (object.userRoleId === UserRole.Manager ||
        object.userRoleId === UserRole.Admin) &&
      object.currentId === UserRole.Sales
    ) {
      this.supportGridRights = false;
    } else {
      this.supportGridRights = true;
    }
  }

  SupportUserList(whoSupportMeAddTableData: UsersList[]) {
    this.usersupportmap.SupportUserList(whoSupportMeAddTableData);
  }
}
